import { createFileRoute } from '@tanstack/react-router'
import { Suspense, lazy } from 'react'
import { z } from 'zod'
import { protectedRouteGuard } from '@/utils/routeGuards'

import { Loading } from '@/components/Loading'

const ServersPage = lazy(
  () => import('@/features/Servers/pages/ServersListPage'),
)

const serversSearchSchema = z.object({
  cluster: z.string().optional(),
  nodeType: z.string().optional(),
})

export const Route = createFileRoute('/infra/servers/')({
  validateSearch: serversSearchSchema,
  beforeLoad: protectedRouteGuard,
  component: () => (
    <Suspense fallback={<Loading />}>
      <ServersPage />
    </Suspense>
  ),
})
